import { render, staticRenderFns } from "./AssignContactDataToSD.vue?vue&type=template&id=7bf08b4b&scoped=true"
import script from "./AssignContactDataToSD.vue?vue&type=script&lang=js"
export * from "./AssignContactDataToSD.vue?vue&type=script&lang=js"
import style0 from "./AssignContactDataToSD.vue?vue&type=style&index=0&id=7bf08b4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf08b4b",
  null
  
)

export default component.exports